import React, { useState, useEffect } from "react";

const LinksAvatar = ({
  onClick,
  isProcessing,
  wrongAttempts,
  streakCount,
  isCorrectAnswer,
  disabled,
}) => {
  const [expression, setExpression] = useState("normal");
  // Track previous wrong attempts to detect changes
  const [prevWrongAttempts, setPrevWrongAttempts] = useState(0);

  // Update expression based on state changes
  useEffect(() => {
    // Clear any existing timers when component updates
    let timer;

    if (isProcessing) {
      setExpression("confused");
      return;
    }

    // Handle correct answers
    if (isCorrectAnswer) {
      // Show excitement or love based on streak
      setExpression(streakCount > 3 ? "loving" : "excited");

      // Return to normal after animation
      timer = setTimeout(() => {
        setExpression("normal");
      }, 2000);

      return () => clearTimeout(timer);
    }

    // Handle wrong attempts - only trigger animation on NEW wrong attempts
    if (wrongAttempts > prevWrongAttempts) {
      // Save current wrong attempts count
      setPrevWrongAttempts(wrongAttempts);

      // Alternate expressions based on even/odd attempts
      setExpression(wrongAttempts % 2 === 0 ? "sad" : "bored");

      // Return to normal after a delay
      timer = setTimeout(() => {
        setExpression("normal");
      }, 3000);

      return () => clearTimeout(timer);
    }

    // If none of the above cases, and we're not processing,
    // ensure we go back to normal when done
    if (expression === "confused") {
      setExpression("normal");
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [
    isProcessing,
    wrongAttempts,
    streakCount,
    isCorrectAnswer,
    prevWrongAttempts,
  ]);

  // Function to prevent default drag behavior
  const preventDrag = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div
      onClick={disabled ? null : onClick}
      style={{
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.7 : 1,
        transition: "all 0.3s ease",
        transform: disabled ? "scale(1)" : undefined,
        width: "clamp(100px, 25vw, 150px)",
        height: "clamp(100px, 25vw, 150px)",
        borderRadius: "50%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        userSelect: "none",
        WebkitUserDrag: "none",
        backgroundColor: "#f3e1b2",
        boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
      draggable="false"
      onDragStart={preventDrag}
    >
      <img
        src={`/links_avatar/${expression}_links.png`}
        alt={`Links with ${expression} expression`}
        style={{
          height: "120%",
          width: "120%",
          objectFit: "contain",
          objectPosition: "center 75%",
          pointerEvents: "none",
          position: "absolute",
          bottom: "-5%",
        }}
        draggable="false"
        onDragStart={preventDrag}
      />
    </div>
  );
};

export default LinksAvatar;
